import React from 'react';
import Alert from '../../../common/helpers/alert';

function GeneralError({
  clearApplicationError,
  errorText
}) {
  if (errorText) {
    return (
      <Alert
        errorString={ errorText }
        onClose={ clearApplicationError }
      />
    );
  }
  return null;
}

export default GeneralError;
